export default __webpack_public_path__ + "static/media/account-edit.5eedf7f7.svg";